import { Link } from "react-router-dom";

const categories = [
  { name: "热血", icon: "ri-fire-line", color: "bg-primary-100 text-primary-700" },
  { name: "校园", icon: "ri-school-line", color: "bg-secondary-100 text-secondary-700" },
  { name: "恋爱", icon: "ri-heart-3-line", color: "bg-accent-100 text-accent-700" },
  { name: "科幻", icon: "ri-planet-line", color: "bg-secondary-100 text-secondary-700" },
  { name: "悬疑", icon: "ri-search-eye-line", color: "bg-foreground-100 text-foreground-700" },
  { name: "搞笑", icon: "ri-emotion-laugh-line", color: "bg-accent-100 text-accent-700" },
  { name: "玄幻", icon: "ri-magic-line", color: "bg-primary-100 text-primary-700" },
  { name: "都市", icon: "ri-building-2-line", color: "bg-secondary-100 text-secondary-700" },
  { name: "冒险", icon: "ri-compass-3-line", color: "bg-primary-100 text-primary-700" },
  { name: "运动", icon: "ri-basketball-line", color: "bg-accent-100 text-accent-700" },
  { name: "治愈", icon: "ri-heart-pulse-line", color: "bg-accent-100 text-accent-700" },
  { name: "奇幻", icon: "ri-sword-line", color: "bg-primary-100 text-primary-700" },
];

export default function CategoryQuick() {
  return (
    <section className="mx-auto w-full max-w-6xl px-4 md:px-8 py-12">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">分类快捷入口</h2>
          <p className="mt-1 text-sm text-foreground-500">按题材快速发现你感兴趣的作品</p>
        </div>
        <Link to="/category/全部" className="text-sm text-primary-600 hover:text-primary-700 whitespace-nowrap flex items-center gap-1">
          全部分类
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 lg:grid-cols-6">
        {categories.map((cat) => (
          <Link
            key={cat.name}
            to={`/category/${encodeURIComponent(cat.name)}`}
            className="group flex flex-col items-center gap-2 rounded-lg border border-background-200 bg-background-50 px-3 py-4 transition-colors hover:border-primary-300 cursor-pointer"
          >
            <span className={`flex h-11 w-11 items-center justify-center rounded-full ${cat.color} transition-transform group-hover:scale-110`}>
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <span className="text-sm text-foreground-700 group-hover:text-primary-600">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}